import React from 'react';
import Dropzone from 'react-dropzone';
import Modal from 'simple-react-modal';
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import './NewGalleryModal.css';
import Loader from 'react-simple-loading';

import { ANCHOR_PRIVATE_GALLERIES } from '../../../constants/apiUrls/apiUrls';
import http from '../../../services/http';
import Alert from '../../../components/generalComponents/Alert';

const MAX_FILE_SIZE = 20971520;
const ACCEPTED_FILE_TYPES = 'image/jpeg, image/jpg, image/png, image/gif';

class NewGalleryModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      galleryName: '',
      imageFiles: [],
      showAlert: false,
      alertMessage: '',
      alertType: '',
      galleryNameError: false,
      imageUploadError: false,
      uploadingImages: false
    };
  }

  onGalleryNameChange = (e) => {
    e.preventDefault();
    this.setState({ galleryName : e.target.value, galleryNameError: false });
  }

  onDrop = (images) => {
    const { imageFiles } = this.state;
    const image = imageFiles.filter(file => file.path === images[0].path);

    // Same image cannot be uploaded twice
    const allowUpload = image.length === 0;
    
    if(allowUpload) {
      this.setState({ imageFiles: [...imageFiles, ...images], imageUploadError: false });
    }
  }

  onDropRejected = (imageFiles) => {
    this.setState({
      showAlert: true,
      alertMessage: "Image has been rejected",
      alertType: "error"
    });
  }

  submitNewGallery = () => {
    this.uploadingImages(true);
    const { user, fetchGalleries } = this.props;
    const { imageFiles, galleryName } = this.state;
    const anchorId = user.user.account.anchor.id;

    if(!galleryName) {
      this.setState({galleryNameError: true}, function() {
        this.uploadingImages(false);
      });
      return;
    }

    if(imageFiles.length === 0) {
      this.setState({imageUploadError: true}, function() {
        this.uploadingImages(false);
      });
      return;
    }

    const formData = new FormData();
    formData.append('name', galleryName);

    imageFiles.forEach(file => {
      formData.append('images', file);
    });

    const url = ANCHOR_PRIVATE_GALLERIES.replace('{id}', anchorId);
    
    http.post(
      url,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data'}
    })
    .then(res => {
      if (res.data && res.status === 200) {
        fetchGalleries();
        this.close();
      }
    })
    .catch(error => {
      this.setState({
        showAlert: true,
        alertMessage: "Something went wrong",
        alertType: "error",
        uploadingImages: false
      });
      console.error(error);
    });
  }

  uploadingImages = flag => {
    this.setState({ uploadingImages: flag });
  }

  handleDelete = (e, image) => {
    e.stopPropagation();
    let updatedImgArray = this.state.imageFiles.filter(file => file.path !== image);
    this.setState({ imageFiles: updatedImgArray });
  }

  renderImagePreviews = () => {
    const { imageFiles } = this.state;
    return imageFiles.map((file, index) => {
      return (
        <div
          key={file.path}
          className="anchor-gallery-image-preview"
        >
          <img src={URL.createObjectURL(file)} alt={file.name}/>
          <span onClick={(e) => this.handleDelete(e, file.path)} className='anchor-gallery-image-delete'>
            <CloseIcon />
          </span>
        </div>
      )
    });
  }

  close = () => {
    this.setState({
      galleryName: '',
      imageFiles: [],
      imageUploadError: false,
      galleryNameError: false,
      uploadingImages: false,
      showAlert: false,
      alertMessage: "",
      alertType: ""
    }, this.props.close);
  }

  hideAlert = () => {
    this.setState({
       showAlert: false,
       alertMessage: '',
       alertType: ''
    })
 }

  render() {
    const { showModal } = this.props;
    const { 
      galleryName, 
      imageFiles, 
      showAlert, 
      alertMessage, 
      alertType,
      galleryNameError,
      imageUploadError,
      uploadingImages
     } = this.state;

    return (
      <Modal
        containerStyle={{
          width: '100%',
          padding: '0',
          marginTop: '100px',
          background: 'transparent',
        }}
        closeOnOuterClick
        show={showModal}
      >
        {showAlert && (
            <Alert onClose={this.hideAlert} type={alertType}>
                {alertMessage}
            </Alert>
        )}
        <div className="anchor-new-gallery-form">
          <h3>Create New Gallery</h3>
          <div className="anchor-new-gallery-inputs">
            <div className="anchor-gallery-name-input">
              <input
                placeholder="Enter gallery name"
                id="anchor-new-gallery-name"
                className='anchor-new-gallery-name-modal'
                type="text"
                value={galleryName}
                onChange={this.onGalleryNameChange}
              />
              {galleryNameError ? 
                <div className='anchor-gallery-error'>Please enter gallery name</div> : null}
            </div>
            <div className="anchor-new-gallery-form__info">
              <p>Max file size is 20 MB.</p>
            </div>
            <div className={`${imageFiles.length > 0 ? '' : 'anchor-gallery-dropzone'}`}>
              <Dropzone
                onDrop={this.onDrop}
                onDropRejected={this.onDropRejected}
                accept={ACCEPTED_FILE_TYPES}
                maxSize={MAX_FILE_SIZE}
              >
                {({getRootProps, getInputProps}) => (
                  <div {...getRootProps()} className={`${imageFiles.length > 0 ? 'anchor-gallery-dropzone-wrapper' : ''}`}>
                    <input {...getInputProps()} />
                    {this.renderImagePreviews()}
                    <div className={`anchor-new-gallery-files ${imageFiles.length > 0 ? 'has-photos' : ''}`}>
                      <p>
                        { imageFiles.length === 0 ?
                          <React.Fragment>
                            <AddIcon />
                            <span>Click here to upload photos</span>
                          </React.Fragment>
                          : <AddCircleOutlineIcon />
                        }
                      </p>
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
            {imageUploadError ?
                <div className='anchor-gallery-error'>Please select image to upload</div> : null}
            <div className="anchor-new-gallery-actions">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-6">
                  <button
                    className="btn btn-info btn-block montserrat anchor-new-gallery-cancel"
                    onClick={this.close}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6">
                  <button
                  onClick={this.submitNewGallery}
                  className="btn btn-danger btn-block montserrat anchor-new-gallery-publish"
                >
                  Publish
                </button>                  
                </div>
              </div>
            </div>
          </div>
          <div style={{display: `${uploadingImages ? 'block' : 'none'}`}} className='anchor-new-gallery-loader'>
            <div className='anchor-new-gallery-loader-info'>
              <Loader color={'#222222'} />
              <p>Images uploading and the gallery is being published. Hang tight!</p>
            </div>
          </div>
        </div>

      </Modal>
    )
  }
}

export default NewGalleryModal;
